import type { QueryClient } from '@tanstack/react-query'
import { allSettled } from '@lib/utils/all-settled'
import { analytics } from '@services/Analytics'
import type { useClerk } from '~/universal/clerk'

export function createLogoutFn(
  queryClient: QueryClient,
  clerk: ReturnType<typeof useClerk>
) {
  return async () => {
    await queryClient.cancelQueries()

    if (!clerk.loaded) throw new Error('Cannot logout before auth is loaded')
    if (!clerk.session?.id)
      throw new Error('Cannot logout if user is not signed in')

    return allSettled([
      clerk.signOut(),
      analytics.reset(),
      Promise.resolve(queryClient.clear()),
    ])
  }
}
